<template>
  <div id="user-edit-tab-info">
    <form>
      <div class="vx-row">
        <div class="vx-col w-1/4 mb-6 license-col-min-width">
          <label class="vs-input--label">免許区分</label>
          <v-select
            placeholder="免許区分を選択してください"
            class="w-full v-select-license-add"
            label="label"
            name="selectLicenseCategory"
            :options="marineLicenseCategoryOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="selectedCategory"
            v-validate="'required'"
            data-vv-as="免許区分"
            :disabled="true"
            :value="$store.myValue"
          >
            <template v-slot:no-options>免許区分が見つかりません</template>
          </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('selectLicenseCategory')"
            >{{ errors.first("selectLicenseCategory") }}</span
          >
        </div>
        <div class="vx-col w-1/4 mb-6 license-col-min-width">
          <label class="vs-input--label">階級</label>
          <v-select
            placeholder="階級を選択してください"
            class="w-full v-select-license-add"
            label="label"
            name="selectClass"
            :options="marinerClassOptions"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-model="localData.licenseTypeId"
            v-validate="'required'"
            data-vv-as="階級"
          >
            <template v-slot:no-options>階級が見つかりません</template>
          </v-select>
          <span
            class="text-danger text-sm"
            v-show="errors.has('selectClass')"
            >{{ errors.first("selectClass") }}</span
          >
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 w-full license-col-min-width">
          <label class="vs-input--label">有効期限</label>
          <datepicker
            name="selectExpirationDate"
            :language="ja"
            :format="formatter"
            :typeable="true"
            placeholder="日付を選択してください"
            v-model="localData.expirationDate"
            v-validate="'required|custom_isFutureDate'"
            data-vv-as="有効期限"
            :disabled-dates="disabledDates"
            ref="datePickerExpirationDate"
          ></datepicker>
          <span
            class="text-danger text-sm"
            v-show="errors.has('selectExpirationDate')"
            >{{ errors.first("selectExpirationDate") }}</span
          >
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 mt-8 mb-8 w-full license-col-min-width">
          <input-image
            :label="'海技士免状の画像'"
            :imgSrc="imgSrc"
            :styleObject="imageAreaStyleObject"
            @onSetImage="onSetImage"
            @onDeleteImage="onDeleteImage"
            @onClearImage="onClearImage"
            ref="inputImage"
          ></input-image>
        </div>
        <div class="vx-col md:w-1/4 w-full input-form-memo license-col-min-width">
          <label class="vs-input--label">メモ</label>
          <vs-textarea v-model="localData.memo" width="100%" height="200px"/>
        </div>
      </div>
    </form>
    <!-- 更新 & リセット -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button
            id="button-with-loading"
            class="ml-auto mt-2"
            :disabled="!validateForm"
            @click="onSave"
            >変更を保存する</vs-button
          >
          <vs-button
            class="ml-4 mt-2"
            type="border"
            @click="$emit('closePopup')"
            >詳細へ戻る</vs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import LicenseMixin from "@/mixins/LicenseMixin";
import DatepickerMixin from "@/mixins/DatepickerMixin";
import InputImage from "@/components/formElemens/input/InputImage";
import { DateUtil, FileUtil } from "@/utils";
import _ from "lodash";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers(
  "enterpriseLicenseEdit"
);

export default {
  components: {
    Datepicker,
    vSelect,
    InputImage
  },
  mixins: [LicenseMixin, DatepickerMixin],
  data() {
    return {
      localData: null,
      disabled: false,
      selectedCategory: [],
      marinerClassOptions: [],
      activePrompt: false,
      imgSrc: null,
      imageAreaStyleObject: {
        width: "350px",
        height: "230px"
      },
      disabledDates: {
        to: new Date()
      }
    };
  },
  computed: {
    ...mapState({
      user: state => state.user,
      picture: state => state.picture,
      pictureSrc: state => state.pictureSrc,
      inputForm: state => state.inputForm
    }),
    validateForm() {
      return !this.errors.any();
    }
  },
  watch: {
    inputForm: {
      handler: _.debounce(function () {
        this.setImageUrl();
        this.localData = JSON.parse(JSON.stringify(this.inputForm));
      }, 400),
      deep: true
    },
  },
  methods: {
    ...mapActions([
      "setInputForm",
      "saveLicense",
      "setPictureSrc",
      "deletePicture"
    ]),

    setImageUrl() {
      if (this.picture) {
        this.$refs.inputImage.setImgSrc(this.picture.imgSrc);
        this.$refs.inputImage.setEditMode(true);
      }
    },

    setCategory() {
      let category = this.getMarinerLicenseCategoryOptionsById(
        this.inputForm.licenseTypeId.value
      );
      this.selectedCategory = category;
      this.marinerClassOptions = this.getMarinerClassOptions(category.value);
    },

    changeEditMode(isMode) {
      this.$refs.inputImage.setEditMode(isMode);
    },

    onSetImage(evt) {
      let blob = FileUtil.toBlob(evt.src, evt.type);
      this.setPictureSrc(blob);
      this.$refs.inputImage.setEditMode(false);
    },

    async onDeleteImage() {
      await this.deletePicture();
      this.$refs.inputImage.deleteImgSrc();
      this.$refs.inputImage.setEditMode(false);
    },

    onClearImage() {
      this.setPictureSrc(null);
    },

    async onSave() {
      let result = await this.$validator.validateAll();
      if (result) {
        let payload = {
          name: this.localData.name,
          license_type_id: this.localData.licenseTypeId.value,
          expiration_date: DateUtil.toYMD(this.localData.expirationDate),
          memo: this.localData.memo,
        };
        try {
          await this.setInputForm(payload);
          this.$vs.loading({
            type: "default",
            container: "#button-with-loading",
            scale: 0.45
          });
          await this.saveLicense(payload);
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          if (this.pictureSrc) {
            this.$refs.inputImage.setEditMode(true);
            this.setPictureSrc(null);
          }
          this.successUpdate();
        } catch (e) {
          this.$vs.loading.close("#button-with-loading > .con-vs-loading");
          this.failureUpdate(e);
        }
      }
    },

    deleteImage() {
      this.$refs.inputImage.deleteImgSrc();
      this.$refs.inputImage.setEditMode(false);
    },

    successUpdate() {
      this.$vs.notify({
        title: "資格情報を変更しました",
        color: "success",
        iconPack: "feather",
        icon: "icon-check"
      });
      this.$emit('closePopup');
    },

    failureUpdate(e) {
      console.error(e);
      this.$vs.notify({
        title: "資格情報の更新に失敗しました",
        color: "danger",
        iconPack: "feather",
        icon: "icon-x-square",
        position: "top-right"
      });
    }
  },
  created() {
    this.localData = JSON.parse(JSON.stringify(this.inputForm));
  },
  mounted() {
    this.setImageUrl();
    this.setCategory();
    this.customizeExpirationDateElement(this.$refs.datePickerExpirationDate.$el);
  }
};
</script>

<style lang="scss">
#user-edit-tab-info {
  .license-col-min-width {
    min-width: 220px;
  }
  .input-form-memo {
    padding-top: 2rem;
    .vs-con-textarea {
      margin-top: 0.6rem;
    }
    .vs-textarea {
      height: 200px;
    }
  }
}
</style>
